export class passwordComplexityOptions {
    // Default Password settings.  
    requireDigit: boolean = true;
    requireLowercase: boolean = true;
    requireNonAlphanumeric: boolean = true;
    requireUppercase: boolean = true;
    requiredLength: number = 6;
    requiredUniqueChars: number = 1;
}